/*
 * @version: V1.0.0
 * @Date: 2023-11-02 18:00:37
 * @LastEditors: lzq
 * @LastEditTime: 2023-12-25 14:55:33
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\system\custom.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 查询客户列表
export function getCustomList(params) {
  return request({
    url: '/wms/customer/list',
    method: 'get',
    params
  })
}

// 更新客户
export function saveOrUpdateCustom(data) {
  return request({
    url: '/wms/customer/saveOrUpdate',
    method: 'post',
    data
  })
}

// 删除客户
export function deleteCustom(params) {
  return request({
    url: `/wms/customer/remove`,
    method: 'POST',
    params
  })
}


// 查询客户详情
export function getCustomInfo(id) {
  return request({
    url: `/wms/customer/${id}`,
    method: 'get',
  })
}

// 删除客户地址
export function customerRecipientRemove(id) {
  return request({
    url: `/wms/customerRecipient/remove`,
    method: 'post',
    params: {ids: id}
  })
}

